import { Pipe, PipeTransform } from '@angular/core';

const OdmianaRzeczownikowPrzezLiczby = {
  'minuta': {
    mianownikLP: 'minutę',
    mianownikLM: 'minuty',
    dopelniaczLM: 'minut'
  },
  'sekunda': {
    mianownikLP: 'sekunda',
    mianownikLM: 'sekundy',
    dopelniaczLM: 'sekund'
  },
  'zadanie': {
    mianownikLP: 'zadanie',
    mianownikLM: 'zadania',
    dopelniaczLM: 'zadań'
  }
}

@Pipe({
  name: 'odmienDlaLiczby'
})
export class OdmienDlaLiczbyPipe implements PipeTransform {

  transform(mianownik: string, ...args: unknown[]): unknown {
    if (args && args.length) {
      const liczba = +args[0];
      const odmiana = OdmianaRzeczownikowPrzezLiczby[mianownik];
      if (!odmiana)
        return mianownik;
      if (liczba === 1) {
        return odmiana.mianownikLP;
      } else if (liczba % 10 >= 2 && liczba % 10 <= 4 && (liczba % 100 < 10 || liczba % 100 >= 20)) {
        return odmiana.mianownikLM;
      } else {
        return odmiana.dopelniaczLM;
      }
    }
  }

}
